// extracted by mini-css-extract-plugin
export var container = "_36-1";
export var editor = "_36-2";
export var resizable = "_36-3";
export var wrapper = "_36-0";